module.exports = [{
      plugin: require('../node_modules/gatsby-wordpress-inline-images/gatsby-browser.js'),
      options: {"plugins":[],"baseUrl":"localhost","protocol":"http"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
